import { render, staticRenderFns } from "./consultationListContent.vue?vue&type=template&id=1b2b1335&scoped=true"
import script from "./consultationListContent.vue?vue&type=script&lang=js"
export * from "./consultationListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b1335",
  null
  
)

export default component.exports